angular.module('gym.components').directive('privacyModeBar', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/dashboard/privacy_mode_bar.html.slim'),
    scope: {
      disable: '&'
    },
    controller: ["DashboardPrivacyModeService", "$scope", function(DashboardPrivacyModeService, $scope) {
      $scope.isBarVisible = DashboardPrivacyModeService.isBarVisible();
      return $scope.hide = function() {
        $scope.isBarVisible = false;
        return DashboardPrivacyModeService.hideBar();
      };
    }]
  };
});
